import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function SectionHeading({ title, to, linkLabel = "See All", light = false, eyebrow, id }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        {eyebrow && <div className={`eyebrow mb-2 ${light ? "text-gold-light" : "text-gold"}`}>{eyebrow}</div>}
        <h2 id={id} className={`font-serif text-2xl sm:text-3xl font-semibold tracking-tight ${light ? "text-white" : "text-ink"}`}>{title}</h2>
      </div>
      {to && (
        <Link to={to} data-testid={`see-all-${(id || title).toLowerCase().replace(/\s+/g, "-")}`} className={`group inline-flex items-center gap-1.5 text-sm font-medium ${light ? "text-white/80 hover:text-white" : "text-charcoal hover:text-bordeaux"} transition-colors`}>
          {linkLabel} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}

export function PageHero({ eyebrow, title, description, children, dark = false }) {
  return (
    <section className={`${dark ? "bg-ink text-white" : "bg-ivory"} border-b border-[#E6E3DC]`}>
      <div className="container-wei py-12 sm:py-16">
        {eyebrow && <div className="eyebrow text-gold mb-3">{eyebrow}</div>}
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight max-w-4xl">{title}</h1>
        {description && <p className={`mt-4 max-w-2xl text-base ${dark ? "text-white/70" : "text-charcoal"}`}>{description}</p>}
        {children}
      </div>
    </section>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`skeleton rounded-md ${className}`} />;
}
